/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Das28EditionFormComponent from "core/components/abstract/das28-edition-form";
import baseEditionFormStyles from "core/components/das28/base-edition-form/index.module.css";
import { computeDas28Crp } from "core/components/das28/utils/compute-das28";
import { computeCrpOrVsDas28Activity } from "core/components/das28/utils/compute-das28-activity";
import getLastBioExamInfos from "core/components/das28/utils/get-last-bio-exam-infos";
import Das28CrpComputedJournalEvent from "core/models/das28-crp-computed-journal-event";
import dayjs from "dayjs";
export default class Das28CrpEditionFormComponent extends Das28EditionFormComponent {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "currentComputeDas28Function", computeDas28Crp);
    _defineProperty(this, "currentComputeDAS28Activity", computeCrpOrVsDas28Activity);
    _defineProperty(this, "specificDas28Properties", ["crp", "comments"]);
    _defineProperty(this, "baseEditionFormStyles", baseEditionFormStyles);
    _defineProperty(this, "journalEventProperties", [...this.specificDas28Properties, ...this.standardJournalEventProperties, ...this.sharedDas28Properties]);
  }
  get lastBioExamsInfos() {
    //CRP
    const crpCode = "LOINC-1988-5";
    //get only bioExamsJE with crp
    return getLastBioExamInfos(this.patient, "crp", crpCode);
  }
  get lastCrpDate() {
    if (this.lastBioExamsInfos.crp != undefined && this.changeset.get("crp") == this.lastBioExamsInfos.crp) {
      return dayjs(this.lastBioExamsInfos.occurredAt).format("[Dernière mesure le] DD/MM/YYYY");
    }
    return "";
  }
  retrieveModel() {
    const model = super.retrieveModel();
    if (this.isNewMode) {
      model.crp = this.lastBioExamsInfos?.crp;
    }
    return model;
  }
}
_defineProperty(Das28CrpEditionFormComponent, "forcDisplayName", "Calculer le DAS 28 CRP");
_defineProperty(Das28CrpEditionFormComponent, "fullComponentId", "das28/das28-crp-edition-form");
_defineProperty(Das28CrpEditionFormComponent, "journalEventClass", Das28CrpComputedJournalEvent);